import React, { useState, useContext, useEffect } from 'react'

import { Form, Input, InputNumber, Modal, Popconfirm, Select } from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import MESSAGES from '../../services/messages'
import api from '../../services/api'
import RecoverPassword from '../../components/modals/RecoverPassword';
import SL_Button from '../../components/buttons/Button';
import { displayMessage } from '../../services/helper'
import { MaskedInput } from 'antd-mask-input'
import SL_Date from '../../components/dates/Date';
import moment from 'moment'
import SL_Select from '../../components/selects/Select';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

const inputsClassName = `border-appian-blue max-h-9 text-base`

const { Option } = Select

export default function DetailPatient(props) {

    const [form] = Form.useForm()

    const [patient, setPatient] = useState(null)
    const [edit_mode, setEditMode] = useState(false)
    const [dentists, setDentists] = useState([])
    const [email, setEmail] = useState(null)
    const [isModalRecoverPasswordOpen, setIsModalRecoverPasswordOpen] = useState(false)
    const [visiblePassword, setVisiblePassword] = useState(false)

    const { handleOnClickSendReport, handloOnClickSpendMangos, handloOnClickGainMangos, currentPatient, handloOnClickOpenMangoHistory } = props
    const { setShowLoading, windowHeight, mobile_mode, enums } = useContext(GeneralContext)

    useEffect(() => {
        loadPatient()
        loadDentists()
    }, [currentPatient])


    const loadDentists = () => {
        setShowLoading(true)

        api.dentist.list().then(
            rs => {
                setDentists(rs.data)
                setShowLoading(false)
            }
        )
    }

    function loadPatient() {
        setShowLoading(true)
        api.patient.get(props.patient_id)
            .then(
                rs => {
                    rs.data.birth_date = moment(rs.data.birth_date)
                    setPatient(rs.data)
                    form.setFieldsValue(rs.data)
                }
            )
            .finally(
                setShowLoading(false)
        )
    }

    const handleUpdatePatient = async (values) => {
        setShowLoading(true)
        try {
            values.id = patient.id
            await api.patient.update(values)
            alert(displayMessage('CREATE_PATIENT_SUCCESS'), 'success', displayMessage('SUCCESS'))
            props.handleOnCloseModal()
            props.refreshPatients()
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const phoneField = placeholder => {
        if (edit_mode) {
            return (
                <MaskedInput
                    type="text"
                    size='large'
                    placeholder={placeholder}
                    className={inputsClassName}
                    defaultValue={patient?.cell_phone_responsible}
                    mask={ '(00) 00000-0000' }
                />
            )
        } else {
            return (
                <div style={{ fontSize: 16, border: '1px solid #1c3663', padding: 5, paddingTop: 4, paddingLeft: 11, background: '#f5f5f5', color: '#b7b7b7' }}>
                    {patient?.cell_phone_responsible}
                </div>
            )
        }
    }

    const cpfField = (placeholder, value) => {
        if (edit_mode) {
            return (
                <MaskedInput
                    type="text"
                    size='large'
                    placeholder={placeholder}
                    className={inputsClassName}
                    defaultValue={patient?.cpf}
                    mask={ '000.000.000-00' }
                />
            )
        } else {
            return (
                <div style={{ fontSize: 16, border: '1px solid #1c3663', padding: 5, paddingTop: 4, paddingLeft: 11, background: '#f5f5f5', color: '#b7b7b7' }}>
                    {patient?.cpf}
                </div>
            )
        }

    }

    const cpfResponsibleField = (placeholder, value) => {
        if (edit_mode) {
            return (
                <MaskedInput
                    type="text"
                    size='large'
                    placeholder={placeholder}
                    className={inputsClassName}
                    defaultValue={patient?.cpf_responsible}
                    mask={ '000.000.000-00' }
                />
            )
        } else {
            return (
                <div style={{ fontSize: 16, border: '1px solid #1c3663', padding: 5, paddingTop: 4, paddingLeft: 11, background: '#f5f5f5', color: '#b7b7b7' }}>
                    {patient?.cpf_responsible}
                </div>
            )
        }

    }

    function handleOnCloseModalRecoverPassword(){
        setIsModalRecoverPasswordOpen(false)
        setEmail(null)
    }

    async function handleOkPasswordRecovery() {
        setShowLoading(true)
        try {
            if (!email) {
                alert(displayMessage('INVALID_EMAIL'), 'error')
                return
            }
            await api.auth_patient.forgotPassword(email)
            alert(displayMessage('FORGOT_PASSWORD_SUCCESS'), 'success')
            handleOnCloseModalRecoverPassword()
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const modalHeader = (
        <div style={{ display: 'wrap', flexDirection: mobile_mode ? 'column' : 'row' }}>
            <div className="text-xl font-bold text-appian-blue" style={{ display: 'flex', justifyContent: mobile_mode ? 'center' : 'flex-start', marginBottom: mobile_mode ? 10 : ''}}>
                {displayMessage('DETAIL_PATIENT')}
            </div>
            <div style={{ marginTop: 10, display: 'flex', flex: 1, flexDirection: 'column', gap: 7 }}>
                <div style={{display: 'flex', flex: 1, justifyItems: 'center', alignContent: 'center', gap: 5, flexDirection: mobile_mode? 'column' : 'row'}}>
                    <div style={{display: 'flex', flex: 2 ,flexDirection: 'row', gap: 5 }}>
                        <SL_Button
                            type={edit_mode ? "danger" : "primary"}
                            styles={{ display: 'flex', flex:1 }}
                            htmlType="submit"
                            className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                            onClick={
                                e => {
                                    setEditMode(!edit_mode)
                                    form.setFieldsValue(patient)
                                }
                            }
                        >
                            {edit_mode ? displayMessage('CANCEL') : displayMessage('EDIT')}
                        </SL_Button>
                        <Popconfirm
                            zIndex={10001}
                            placement="topLeft"
                            title={displayMessage('COMFIRMATION_SEND_REPORT')}
                            onConfirm={() => handleOnClickSendReport(patient)}
                            okText={displayMessage('YES')}
                            cancelText={displayMessage('NO')}
                        >
                            <SL_Button
                                type={"primary"}
                                styles={{ display: 'flex', flex:1 }}
                                htmlType="submit"
                                className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                            >
                                {displayMessage('SEND_REPORT')}
                            </SL_Button>
                        </Popconfirm>
                    </div>
                    <div style={{display: 'flex', flex: 1}}>
                        <SL_Button
                            type={"primary"}
                            htmlType="submit"
                            className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                            onClick={() => { setIsModalRecoverPasswordOpen(true); setEmail(null) }}
                        >
                            {displayMessage('RESET_PASSWORD')}
                        </SL_Button>
                    </div>
                </div>

                <div style={{display: 'flex', flex: 1, justifyItems: 'center', alignContent: 'center', gap: 5, flexDirection: mobile_mode? 'column' : 'row'}}>
                    <div style={{display: 'flex', flex: 2 ,flexDirection: 'row', gap: 5 }}>
                        <SL_Button
                            type={"primary"}
                            styles={{ display: 'flex', flex:1 }}
                            htmlType="submit"
                            className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                            onClick={e => handloOnClickSpendMangos(patient)}
                        >
                            {displayMessage('SPEND_MANGOS')}
                        </SL_Button>
                        <SL_Button
                            type={"primary"}
                            styles={{ display: 'flex', flex:1 }}
                            htmlType="submit"
                            className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                            onClick={e => handloOnClickGainMangos(patient)}
                        >
                            {displayMessage('GAIN_MANGOS')}
                        </SL_Button>
                    </div>
                    <div style={{display: 'flex', flex: 1 }}>
                        <SL_Button
                            type={"primary"}
                            htmlType="submit"
                            styles={{ display: 'flex', flex:1 }}
                            className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                            onClick={e => handloOnClickOpenMangoHistory(patient)}
                        >
                            {displayMessage('HISTORY_MANGOS')}
                        </SL_Button>
                    </div>
                </div>
            </div>
        </div >
    )

    const togglePasswordVisibility = () => {
        setVisiblePassword(!visiblePassword);
      };
    return (
        <>
            {isModalRecoverPasswordOpen && 
                <RecoverPassword
                    isModalRecoverPasswordOpen={isModalRecoverPasswordOpen}
                    handleOnCloseModalRecoverPassword={handleOnCloseModalRecoverPassword}
                    handleOnOkRecoverPassword={handleOkPasswordRecovery}
                    email={email}
                    setEmail={setEmail}
                />
            }
            <Modal
                title={modalHeader}
                visible={props.isModalVisible}
                onCancel={props.handleOnCloseModal}
                centered={true}
                width={750}
                style={{ position: 'relative' }}
                bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
                footer={<div></div>}
            >
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <img src={patient?.image_url} style={{ height: 100, width: 100, borderRadius: "50%" }} />
                    <div style={{ marginTop: 70, marginLeft: 10 }} className='font-bold text-lg text-appian-blue text-center'>{displayMessage('PATIENT_DATA')}</div>
                </div>
            
                <div style={{ borderBottom: '1px solid lightgray', width: '100%', marginTop: 8 }}></div>
            
                <Form
                    className='w-full flex flex-col gap-2 p-5'
                    onFinish={handleUpdatePatient}
                    layout="vertical"
                    requiredMark='optional'
                    form={form}
                >
                    <div>
            
                        <Form.Item
                            label={displayMessage('NAME')}
                            name="first_name"
                            className={`w-full flex`}
                            rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                        >
                            <Input
                                type="text"
                                size='large'
                                disabled={!edit_mode}
                                placeholder={displayMessage('NAME')}
                                className={inputsClassName}
                            />
                        </Form.Item>
                        <Form.Item
                            label={displayMessage('LAST_NAME')}
                            name="last_name"
                            className={`w-full flex`}
                            rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                        >
                            <Input
                                type="text"
                                size='large'
                                disabled={!edit_mode}
                                placeholder={displayMessage('LAST_NAME')}
                                className={inputsClassName}
                            />
                        </Form.Item>
            
                        <Form.Item
                            label={displayMessage('APP_LOGIN')}
                            name="login"
                            className={`w-full flex`}
                            rules={[
                                {whitespace: true, message: displayMessage('LOGIN_NOT_NULL_WARNING')},
                                {pattern: /^\S*$/, message: displayMessage('LOGIN_WHITSPACE_WARNING')},
                            ]}
                        >
                            <Input
                                type="text"
                                size='large'
                                disabled={!edit_mode}
                                placeholder={displayMessage('APP_LOGIN')}
                                className={inputsClassName}
                            />
                        </Form.Item>
                                
                        <Form.Item
                            label={displayMessage('APP_PASSWORD')}
                            name="password_decrypted"
                            className={`w-full flex`}
                        >
                            <Input
                                suffix={
                                visiblePassword ? (
                                    <EyeOutlined  onClick={() => edit_mode && togglePasswordVisibility()} />
                                ) : (
                                    <EyeInvisibleOutlined onClick={() => edit_mode && togglePasswordVisibility()} />
                                )}
                                type={visiblePassword ? 'text' : 'password'}
                                size='large'
                                disabled={!edit_mode}
                                placeholder={displayMessage('PASSWORD') + displayMessage('PASSWORD_EXEMPLE')}
                                className={inputsClassName}
                            />
                        </Form.Item>
                            
                        <Form.Item
                            label={displayMessage('CPF')}
                            name="cpf"
                            className={`w-full flex`}
                        >
                            {cpfField(displayMessage('CPF'))}
                        </Form.Item>
                            
                        <Form.Item
                            label={displayMessage('BIRTHDAY')}
                            name="birth_date"
                            className={`w-full flex`}
                        >
                            <SL_Date
                                className={inputsClassName}
                                disabled={!edit_mode}
                                style={{ width: '100%', height: 110 }}
                                format={'DD/MM/YYYY'}
                            />
                        </Form.Item>
                            
                        <Form.Item
                            label={displayMessage('IDENTIFICATOR_PATIENT')}
                            name="identificator_patient"
                            className={`w-full flex`}
                        >
                            <Input
                                type="text"
                                size='large'
                                disabled={!edit_mode}
                                placeholder={displayMessage('IDENTIFICATOR_PATIENT')}
                                className={inputsClassName}
                            />
                        </Form.Item>
                            
                        <Form.Item
                            label={"Foto"}
                            name="image_url"
                            className={`w-full flex`}
                            disabled={!edit_mode}
                        >
                            <Input
                                type="text"
                                disabled={!edit_mode}
                                size='large'
                                placeholder={displayMessage('SET_IMAGE_LINK')}
                                className={inputsClassName}
                            
                            />
                        </Form.Item>
                            
                        {patient != null &&
    
                            edit_mode ?
                            <Form.Item
                                label={displayMessage('SEX_GENDER')}
                                name="gender"
                                className={`w-full flex`}
                            >
                                <Select
                                    className={`w-full flex`}
                                    disabled={!edit_mode}
                                    placeholder={displayMessage('SELECT_OPTION')}
                                >
                                    {
                                        Object.values(enums?.EGenderTypes).map(
                                            type => <Option value={type?.code}>{type.description}</Option>
                                        )
                                    }
                                </Select>
                                
                            </Form.Item>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', rowGap: 5, marginBottom: 15 }}>
                                <div style={{ display: 'flex', columnGap: 3 }}>
                                    <span >{displayMessage('SEX_GENDER')}</span>
                                    <span style={{ color: 'gray' }}>{`(optinal)`}</span>
                                </div>
                                
                                <Input value={patient?.gender_formatted?.description} disabled></Input>
                            </div>
                        }
    
                        <Form.Item
                            label={displayMessage('DENTIST')}
                            name="dentist_id"
                            className={`w-full flex`}
                            rules={[{ required: true, message: displayMessage('DENTIST_MANDATORY') }]}
                        >
                            <SL_Select
                                className={`w-full flex`}
                                disabled={!edit_mode}
                                placeholder={displayMessage('SELECT_OPTION')}
                            >
                                {
                                    dentists?.map(
                                        dentist => <Option value={dentist?.id}>{dentist?.first_name + " " + dentist?.last_name}</Option>
                                    )
                                }
                            </SL_Select>
                        </Form.Item>
                            
                            
                        <div className='mt-1 font-bold text-lg text-appian-blue text-center' >
                            {displayMessage('RESPONSIBLE_DATA')}
                        </div>
                        <div className='flex flex-col mb-1'>
                            <Form.Item
                                label={displayMessage('NAME')}
                                name="first_name_responsible"
                                className={`w-full flex`}
                            >
                                <Input
                                    type="text"
                                    size='large'
                                    disabled={!edit_mode}
                                    placeholder={displayMessage('NAME')}
                                    className={inputsClassName}
                                />
                            </Form.Item>
                            <Form.Item
                                label={displayMessage('LAST_NAME')}
                                name="last_name_responsible"
                                className={`w-full flex`}
                            >
                                <Input
                                    type="text"
                                    size='large'
                                    disabled={!edit_mode}
                                    placeholder={displayMessage('LAST_NAME')}
                                    className={inputsClassName}
                            
                                />
                            </Form.Item>
                            
                            <Form.Item
                                label={displayMessage('CPF')}
                                name="cpf_responsible"
                                className={`w-full flex`}
                            >
                                {cpfResponsibleField(displayMessage('CPF'))}
                            </Form.Item>
                            
                            <Form.Item
                                label={displayMessage('EMAIL')}
                                name="email"
                                className={`w-full flex`}
                            >
                                <Input
                                    type="text"
                                    size='large'
                                    disabled={!edit_mode}
                                    placeholder={displayMessage('EMAIL')}
                                    className={inputsClassName}
                            
                                />
                            </Form.Item>
                            
                            <Form.Item
                                label={displayMessage('PHONE_WHATSAPP')}
                                name="cell_phone_responsible"
                                className={`w-full flex`}
                            >
                                { phoneField(displayMessage('PHONE_WHATSAPP')) }
                            </Form.Item>
                            
                            <Form.Item
                                label={displayMessage('PATIENT_BALANCE')}
                                name="patient_balance"
                                className={inputsClassName}
                            >
                                <InputNumber
                                    size='large'
                                    disabled={!edit_mode}
                                >
                                </InputNumber>
                            </Form.Item>
                            
                        </div>
                            
                        {
                            edit_mode ?
                                <SL_Button
                                    type="primary"
                                    size='large'
                                    htmlType="submit"
                                    className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                                >
                                    {displayMessage('UPDATE_PATIENT')}
                                </SL_Button>
                                :
                                null
                        }
                    </div>
                </Form>
            </Modal >
        </>
    )
}

